(() => {
  function initialize(scope) {
    scope.querySelectorAll('.sh-shop-hub__brand-search').forEach(form => {
      if (form.dataset.initialized) return;
      form.dataset.initialized = 'true';
      form.addEventListener('submit', event => {
        const select = form.querySelector('select');
        const option = select.selectedOptions[0];
        if (!option?.value) return;
        event.preventDefault();
        window.location.assign(option.dataset.url || `${form.action}?q=${encodeURIComponent(option.value)}`);
      });
    });
  }
  initialize(document);
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
